import React from "react";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import border from "../../images/border.png";
import customer from "../../images/customer.png";
import "./AboutPage.css";
import FlashSale from "../Flash Sale/FlashSale";
import AboutUs from "../../images/whyus2.jpg";
import {
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

import img1 from "../../images/A1.jpg";
import img2 from "../../images/A2.jpg";
import img3 from "../../images/A3.jpg";
import img4 from "../../images/A4.jpg";
import img5 from "../../images/A5.jpg";
import img6 from "../../images/A6.jpg";
import img7 from "../../images/A7.jpg";
import img8 from "../../images/A8.jpg";
import img9 from "../../images/A9.jpg";
import img10 from "../../images/A10.jpg";
import img11 from "../../images/A11.jpg";
import img12 from "../../images/A12.jpg";
import img13 from "../../images/A13.jpg";
import img14 from "../../images/A14.jpg";
import img15 from "../../images/A15.jpg";
import img16 from "../../images/A16.jpg";
import img17 from "../../images/A17.jpg";
import img18 from "../../images/A18.jpg";
import img19 from "../../images/A19.jpg";
import img20 from "../../images/A20.jpg";
import img21 from "../../images/A21.jpg";
import img22 from "../../images/A22.jpg";
import img23 from "../../images/A23.jpg";
import img24 from "../../images/A24.jpg";
import img25 from "../../images/A25.jpg";
import img26 from "../../images/A26.jpg";
import img27 from "../../images/A27.jpg";
import img28 from "../../images/A28.jpg";

const reviews = [
  {
    name: img1,
  },
  {
    name: img2,
  },
  {
    name: img3,
  },
  {
    name: img4,
  },
  {
    name: img5,
  },
  {
    name: img6,
  },
  {
    name: img7,
  },
  {
    name: img8,
  },
  {
    name: img9,
  },
  {
    name: img10,
  },
  {
    name: img11,
  },
  {
    name: img12,
  },
  {
    name: img13,
  },
  {
    name: img14,
  },
  {
    name: img15,
  },
  {
    name: img16,
  },
  {
    name: img17,
  },
  {
    name: img18,
  },
  {
    name: img19,
  },
  {
    name: img20,
  },
  {
    name: img21,
  },
  {
    name: img22,
  },
  {
    name: img23,
  },
  {
    name: img24,
  },
  {
    name: img25,
  },
  {
    name: img26,
  },
  {
    name: img27,
  },
  {
    name: img28,
  },
];

const AboutPage = () => {
  const aboutuscontent =
    "Our Brand 'प्रथमेश बाळाचे कपडे', founded on 18th February 1999 in Thane, has a Rich Legacy of more than 25 Glorious years, serving a wide range of Infant Baby Clothing, Toys, Cradles, Accessories & lots more all under one roof! Moving ahead with time, we are operating as 'Kharutaai' since April 2024.. Explore our Baby Bucket List & cherish your Parenthood Journey with us! ";
  const aboutuscontent2 =
    "'Prathamesh,' derived from the Maharashtrian language, holds profound cultural & spiritual significance. It comes from combining 'Pratham,'' which means 'first,' & 'Esh,'' referring to Lord Ganesha. In our tradition, Lord Ganesha is known as the bringer of Success & Prosperity. So, 'Prathamesh' symbolizes Lord Ganesha, bringing blessings for good starts, prosperity, & divine protection. This name reflects our commitment to providing the best for infants & fostering a nurturing environment from the very beginning of their journey.";

  const ourvisioncontent =
    "With the Younger Generation leading the way, Our Aim is to remain a symbol of Top-Notch Quality & we are ready to welcome & adapt to new Opportunities. We are dealing into Wide Varieties of Exclusive Hand Stitched Clothing for Ethnic Wear to Casuals & Lots more! We assure to meet the changing needs of our newer generations while staying true to the values that define us!";

  const corevaluescontent =
    "Our Brand has been highly recognized & well-known for serving Soft & Comfortable Clothing for Infant Babies. 'Kharutaai' strives to explore brighter prospects to nurture & grow 'Prathamesh Balache Kapade' as 'Kharutaai' based on the solid groundwork laid by our Founders!";

  const meetourfamilycontent =
    "Mr. Prathamesh Dilip More, Mr. Narayan Prashant Shetye, Mr. Milind Sadashiv Bhise, Mrs. Khushi Narayan Shetye, Mrs. Priya Milind Bhise, Mr. Rishikesh Aswar!";

  const ourbabyfam =
    "Our Beloved Founders Mrs. Geeta Dilip More & Mr. Dilip Vishnu More, relentless dedication & unwavering commitment to providing the Best for Infants have been the Corner Stone of our Success. Their Journey from Humble Beginnings to Building a Reputable Brand has been nothing short of mesmerizing.";

  const ourbabyfam2 =
    "Moving ahead with time, we are a Brand with Newer Aspirations of our New Team led by Mr. Prathamesh Dilip More, Mr. Narayan Prashant Shetye, Mr. Milind Sadashiv Bhise!";

  return (
    <div style={{ margin: "0", padding: "0" }}>
      <Header />
      {/* <div className="aboutus-herosection-container"></div> */}
      <img
        src={AboutUs}
        alt="About Us"
        style={{
          width: "100%",
          minHeight: "200px",
          height: "800px",
        }}
      />
      <div className="aboutus-aboutsection aboutuspage_section">
        <h1>Welcome to our Little World for Infants & Babies</h1>
        <div className="aboutus-titlebottomimage">
          <img src={border} alt="img" />
        </div>
        <p>{aboutuscontent}</p>
        <h1>Our Baby Fam!</h1>
        <div className="aboutus-titlebottomimage">
          <img src={border} alt="img" />
        </div>
        <p>{ourbabyfam}</p>
        <p>{ourbabyfam2}</p>
      </div>
      <div className="aboutus-visionsection aboutuspage_section">
        <h1>Our Vision</h1>

        <div className="aboutus-titlebottomimage">
          <img src={border} alt="img" />
        </div>
        <p>{ourvisioncontent}</p>
      </div>
      <div className="aboutus-corevaluessection aboutuspage_section">
        <h1>Core Values</h1>
        <div className="aboutus-titlebottomimage">
          <img src={border} alt="img" />
        </div>
        <p>{corevaluescontent}</p>
      </div>
      <div className="aboutus-meetourfamilysection aboutuspage_section">
        <h1>Our Core Team</h1>
        <div className="aboutus-titlebottomimage">
          <img src={border} alt="img" />
        </div>
        <p>{meetourfamilycontent}</p>
      </div>
      <ReviewsBox />
      <Footer />
    </div>
  );
};

function ReviewsBox() {
  return (
    <div className="customer-stories">
      <h1>Customer Stories</h1>
      <div
        className="aboutus-titlebottomimage"
        style={{ marginBottom: "30px" }}
      >
        <img src={border} alt="img" />
      </div>
      <Swiper
        effect={"coverflow"}
        modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
        slidesPerView={"auto"}
        loop={true}
        grabCursor
        style={{
          "--swiper-navigation-color": "white",
          "--swiper-navigation-size": "40px",
          "--swiper-pagination-color": "white",
          "--swiper-pagination-bullet-size": "11px",
        }}
        autoplay={{
          delay: 2500,
        }}
        initialSlide={1}
        centeredSlides={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 15,
          depth: 100,
          modifier: 1.2,
          slideShadows: false,
        }}
      >
        {reviews.map((review, index) => (
          <SwiperSlide
            key={index}
            className="reviewslide"
            style={{ padding: "20px", borderRadius: "10px" }}
          >
            <div className="d-flex align-items-center gap-">
              <img src={review.name} className="reviewslide_image" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default AboutPage;
